import { render, staticRenderFns } from "./goalItem.vue?vue&type=template&id=313bd278&scoped=true&"
import script from "./goalItem.vue?vue&type=script&lang=js&"
export * from "./goalItem.vue?vue&type=script&lang=js&"
import style0 from "./goalItem.vue?vue&type=style&index=0&id=313bd278&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313bd278",
  null
  
)

export default component.exports